import { Component, HostBinding, Input } from '@angular/core';
import { ControlValueAccessor, FormsModule } from '@angular/forms';
import { iValidatedControl } from '../iValidatedControl';
import { BaseCustomControl } from '../baseCustomControl';

@Component({
  selector: 'app-checkbox',
  imports: [FormsModule],
  templateUrl: './checkbox.html',
  styles: ``,
})
export class Checkbox extends BaseCustomControl  implements ControlValueAccessor, iValidatedControl {

  @HostBinding('class.formField') formFieldClass = true; // Always applied
  @HostBinding('class.readOnly') get isReadOnly() {
    return this.readonly;
  }

  override ngOnInit(): void {
    super.ngOnInit();

    if ((!this.validationMsg || this.validationMsg == "") && this.required) {
      this.validationMsg = "required";
    }

    this.required = true;
    this.validationMsg = "Required";
    this.isValid = false;
  }
  
  // This writes the boundValue back to the Angular model
  handle_change(e:any):void {
      this.onChange(this.boundValue);

      if (this.onChanged) {
        this.onChanged.emit(this.boundValue);
      };
  }  

  public validate():boolean {
    return true;
  }


}
